import logo from './logo.svg';
import './App.css';
import React, { useState, useRef } from 'react';

import { Layout , Image, Flex, Select, Button, Input, message, Spin, Modal } from 'antd';
import { Divider, Typography } from 'antd';
import { BrowserRouter as Router, Route, useRoutes, Link, Routes, useLocation } from 'react-router-dom';

function HomePage() {

    // 使用 useLocation 钩子获取当前 URL 的 location 对象
    const location = useLocation();
    const current_url = window.location.href;
    // 创建一个 URLSearchParams 实例来解析查询参数
    const queryParams = new URLSearchParams(location.search);
    const r = queryParams.get('i'); // 获取查询参数 'r'
    const rr = atob(r);
    const uuid = r && rr && rr.indexOf("|") > 0 ? rr.split("|")[0] : "";
    const uemail = r && rr && rr.indexOf("|") > 0 ? ( rr.split("|").length > 1 ? rr.split("|")[1] : "" ) : "";

    console.log(r,rr,uuid,uemail);
    const source_name = useRef(null); // 创建一个 ref
    const source_email = useRef(null); // 创建一个 ref

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
      setIsModalOpen(true);
    };

    const handleOk = () => {
      setIsModalOpen(false);
      document.getElementById("form").submit();
    };

    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const { Header, Content, Footer } = Layout;
    const { Title, Paragraph, Text, Link } = Typography;
  
    const [selectedValue, setSelectedValue] = useState('');
    const [errorSelect, setErrorSelect] = useState('');
  
    const handleChange = (value) => {
      setSelectedValue(value);
      document.getElementById("select").value = value;
      setErrorSelect(''); // 清除错误信息
      console.log(`selected ${value}`);
    };
  
    var [email, setEmail] = useState(uuid);
    var [phone, setPhone] = useState(uemail);
    const [errorEmail, setErrorEmail] = useState('');
    const [errorPhone, setErrorPhone] = useState('');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // 邮箱格式
    const phoneRegex = /^\d{3,8}$/; // 手机号码格式（10或11位数字）
  
    const handleChangeEmail = (e) => {
      setEmail(e.target.value);
      setErrorEmail(''); // 清除错误信息
    };
  
    const handleChangePhone = (e) => {
      setPhone(e.target.value);
      setErrorPhone(''); // 清除错误信息
    };
  
    // const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = React.useState(false);
    const [percent, setPercent] = React.useState(0);
    const showLoader = () => {
      setSpinning(true);
      let ptg = -10;
      const interval = setInterval(() => {
        ptg += 5;
        setPercent(ptg);
        if (ptg > 120) {
          clearInterval(interval);
          setSpinning(false);
          setPercent(0);
        }
      }, 100);
    };

    const handleSubmit = () => {
      console.log(source_name.current.input.value);
      console.log(source_email.current.input.value);
      console.log(email);
      console.log(phone);

      if (!selectedValue) {
        setErrorSelect('请先选择一个充值金额');
        message.error('请先选择一个充值金额');
        return false;
      }
  
      if (!email || !phoneRegex.test(email)) {
        setErrorEmail('请输入正确的UID'); // 设置错误信息
        message.error('请输入正确的UID'); // 弹出错误提示
        return false;
      } else if(!phone || !emailRegex.test(phone) ){
        setErrorPhone('请输入正确的EMAIL地址'); // 设置错误信息
        message.error('请输入正确的EMAIL地址'); // 弹出错误提示
        return false;
      } else {
        // 处理提交逻辑
        console.log('提交的值：', email,phone);
        // message.success('提交成功，请稍后转到收银台!');
        // messageApi.open({
        //   type: 'loading',
        //   content: '提交成功，请稍后，正在转到收银台...',
        //   duration: 0,
        // });
        // Dismiss manually and asynchronously
        // setTimeout(messageApi.destroy, 5000);

        showLoader();

        // 清空输入
        setSelectedValue('');
        setEmail('');
        setPhone('');

        if( uuid == email && email == source_name.current.input.value ){ //参数==所有input值，参数的值没有被更改
          document.getElementById("form").submit();
          // alert("提交");
        }else{ //参数 != 所有input值，参数的值被更改
          if(uuid == ""){ //没有参数
            document.getElementById("form").submit();
            // alert("提交");
          }else{
            showModal();
          }
        }
        // document.getElementById("form").submit();
      }
    };
  
    document.title = "优惠充值活动-首页";

    return (
      <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header style={{ backgroundColor: '#001529', color: '#fff', display: 'flex', alignItems: 'center' , justifyContent: 'flex-start', padding: '0 20px'}}>
          <Image width={25} src="https://cdn.splash.lifeano.cn/lifeano_logo.png" alt="Logo" style={{ borderRadius: '50%' }}/>
          <span style={{ margin: 0, marginLeft: '16px', color: '#fff', fontSize:'16px'}}>金币优惠充值活动</span>
        </Header>
        <Content style={{ display: 'flow', justifyContent: 'center', alignItems: 'center', flex: 1 , padding: '10px'}}>
          {/* <Flex gap="middle" vertical style={{ width: '200px' }}> */}
            <Typography>
              <Title>活动介绍</Title>
              <Paragraph>
                所有金币充值享8折，活动时间 11.11 - 12.12 。
              </Paragraph>
              <Paragraph>
                支付成功后请妥善保留支付凭证，我们将依据付款时间的顺序，依次进行充值，请您耐心等候。
              </Paragraph>
              <Paragraph>
                <Link href="https://work.weixin.qq.com/kfid/kfcef54d3112165a3a8" target="_blank" rel="noopener noreferrer">
                  如有问题请及时咨询客服
                </Link>
              </Paragraph>
            </Typography>
            <Divider dashed />
            <h2 style={{ margin: 0 , marginTop:'20px' }}>请选择充值金额</h2>
            <form action="http://xjad.top:8080/stripe_order_create" method="post" id='form'>
            <Select defaultValue="请选择" style={{ width: '100%', marginTop:'10px' }} size='large'
              onChange={handleChange}
              options={[
                {
                  label: <span>苍穹</span>,
                  title: '苍穹',
                  options: [
                    {
                      label: <span>998COIN（798.6元）</span>,
                      value: '998',
                    },
                  ],
                },
                {
                  label: <span>盛花</span>,
                  title: '盛花',
                  options: [
                    {
                      label: <span>698COIN（558.6元）</span>,
                      value: '698',
                    },
                    {
                      label: <span>388COIN（310.6元）</span>,
                      value: '388',
                    },
                    {
                      label: <span>208COIN（166.6元）</span>,
                      value: '208',
                    },
                  ],
                },
                {
                  label: <span>幼芽</span>,
                  title: '幼芽',
                  options: [
                    {
                      label: <span>68COIN（54.6元）</span>,
                      value: '68',
                    },
                    {
                      label: <span>6COIN（4.8元）</span>,
                      value: '6',
                    },
                  ],
                },
              ]}
            />
            {errorSelect && <div style={{ color: 'red', marginBottom: '10px' }}>{errorSelect}</div>}
            <input type='hidden' id='select' name="coin"></input>
  
            <h2 style={{ margin: 0 , marginTop:'20px' }}>请填写联系信息</h2>
            <Paragraph style={{ color:'grey' , fontSize:'12px'}}>
                UID 即APP【个人中心】首页中的ID数字，EMAIL是您常用的邮件地址，如下方已经自动填充且正确，请不要修改。
            </Paragraph>
            <Input placeholder="请输入UID，用于充值到您的账号" variant="filled" style={{ margin: 0 , marginTop:'10px' }} value={email} onChange={handleChangeEmail} name="name"/>
            {errorEmail && <div style={{ color: 'red', marginBottom: '10px' }}>{errorEmail}</div>}
            <Input placeholder="请输入邮箱，用于验证是否充值成功" variant="filled" style={{ margin: 0 , marginTop:'10px' }} value={phone} onChange={handleChangePhone} name="email"/>
            {errorPhone && <div style={{ color: 'red', marginBottom: '10px' }}>{errorPhone}</div>}

            {/* {contextHolder} */}
            <Spin spinning={spinning} percent={percent} fullscreen tip='正在加载收银台，请稍后...'/>
            <Modal title="重要提示，账号UID冲突" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
              <p>您填写的UID与APP当前登录账号的UID<Text style={{ fontWeight: 'bold' , color:'red' ,  }}>不一致</Text>。</p>
              <p>您填写的UID<Text style={{ fontWeight: 'bold' , color:'red' ,}}>归属于其他账号</Text>，您将继续为此账号充值吗？</p>
              <p>如果此账号UID<Text style={{ fontWeight: 'bold' }}>属于您的另一账号</Text>，请继续；如果您不确定您的UID，请返回APP进入【个人中心】查看。</p>
            </Modal>
            <Input type='hidden' ref={source_name} name="source_name" value={uuid}></Input>
            <Input type='hidden' ref={source_email} name="source_email" value={uemail}></Input>
            <Input type='hidden' name="source_url" value={current_url}></Input>
            <Button htmlType="button" type="default" style={{ backgroundColor:'#FFC107' , color:'#000', size: 'large' ,width:'100%', marginTop:'10px' , height:'50px'}} onClick={handleSubmit} >立即充值</Button>
            </form>
          {/* </Flex> */}
          {/* 添加更多内容以测试滚动效果 */}

        </Content>
        <Footer style={{ textAlign: 'center', backgroundColor: '#001529', color: '#fff' }}>
          版权所有 Lifeano © 2024
        </Footer>
      </Layout>
    );
  }

  export default HomePage;